import { format, startOfDay, endOfDay, startOfWeek, endOfWeek, startOfMonth, endOfMonth, startOfYear, endOfYear } from "date-fns";
import { fr } from "date-fns/locale";

export const usePeriodDates = (selectedPeriod: string) => {
  const now = new Date();
  
  switch (selectedPeriod) {
    case "day":
      return {
        start: startOfDay(now),
        end: endOfDay(now),
        label: "aujourd'hui"
      };
    case "week":
      return {
        start: startOfWeek(now, { locale: fr }),
        end: endOfWeek(now, { locale: fr }),
        label: `cette semaine (${format(startOfWeek(now, { locale: fr }), 'd', { locale: fr })} au ${format(endOfWeek(now, { locale: fr }), 'd MMMM', { locale: fr })})`
      };
    case "month":
      return {
        start: startOfMonth(now),
        end: endOfMonth(now),
        label: format(now, 'MMMM yyyy', { locale: fr })
      };
    case "year":
      return {
        start: startOfYear(now),
        end: endOfYear(now),
        label: format(now, 'yyyy', { locale: fr })
      };
    default:
      return {
        start: startOfDay(now),
        end: endOfDay(now),
        label: "aujourd'hui"
      };
  }
};